import { ergoBoxFromProxy, ergoBoxToProxy } from "./ergoBox";
export function ergoTxFromProxy(proxy) {
    return {
        ...proxy,
        outputs: proxy.outputs.map(o => ergoBoxFromProxy(o))
    };
}
export function ergoTxToProxy(tx) {
    return {
        ...tx,
        outputs: tx.outputs.map(o => ergoBoxToProxy(o))
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJnb1R4LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2VudGl0aWVzL2VyZ29UeC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQVUsZ0JBQWdCLEVBQWdCLGNBQWMsRUFBQyxNQUFNLFdBQVcsQ0FBQTtBQW9CakYsTUFBTSxVQUFVLGVBQWUsQ0FBQyxLQUFrQjtJQUNoRCxPQUFPO1FBQ0wsR0FBRyxLQUFLO1FBQ1IsT0FBTyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsZ0JBQWdCLENBQUMsQ0FBQyxDQUFDLENBQUM7S0FDckQsQ0FBQTtBQUNILENBQUM7QUFFRCxNQUFNLFVBQVUsYUFBYSxDQUFDLEVBQVU7SUFDdEMsT0FBTztRQUNMLEdBQUcsRUFBRTtRQUNMLE9BQU8sRUFBRSxFQUFFLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDLGNBQWMsQ0FBQyxDQUFDLENBQUMsQ0FBQztLQUNoRCxDQUFBO0FBQ0gsQ0FBQyJ9